import React, { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { useLocation } from "react-router-dom";
import { LoadingScreen } from "../../../UiComponents/LoadingComponent";
import {UpdateorCancelButtons} from "./UpdateorCancelButtons";
import { UrlPath } from "../../../../config/routeConfig";
import {
  getContactLeadAction,
  getContactRankAction,
  getContactRepTypeAction,
  getContactCategoryAction,
} from "../../../actions/CommonAction";
import { SBAAutoComplete, SBAComboBox, SBADropDown } from "../../../UiComponents/SBADropDown";
import moment from "moment";
import  "../../../investor/investor.css";
import { insertOrUpdateContactGeneral } from "../../../../config/apiConfig";
import { sbaAxios } from "../../../utils/sbaAxios";
import { SBNotify } from "../../../utils/sbNotify";
import { getContactsInfoAction, getContactsDataAction } from "../../../actions/contactsAction";
import { ContactGeneralAttributes } from "../../../../config/investorConfig";
import { ToastContainer, toast } from 'react-toastify';
import { SBDatePicker } from "../../../UiComponents/SBDatePicker";

export const GeneralEdit = (props) => {

  const dispatch = useDispatch();
  const history = useNavigate();
  const locationData = useLocation();
  const params = useParams();
  const queryParams = new URLSearchParams(locationData.search);
  const paramValue = queryParams.get('ContactTypeId'); 



  useEffect(() => {
    document.title = `Investor Details`;
    dispatch(getContactLeadAction("ContactLead"));
    dispatch(getContactRankAction("ContactRank"));
    dispatch(getContactRepTypeAction("ContactRepType"));
    dispatch(getContactCategoryAction("ContactCategory"));
   
  }, []);

  const [loading, setLoading] = useState(true);
  const [showSocialSecurityText, setSocialSecurityShowText] = useState(false);
  const [showTaxText, setShowTaxText] = useState(false);

  const Gstate = useSelector((state) => state) || {};
  const contactRepTypeData = Gstate.ContactDetailsEnumValues.ContactRepTypeData || [];
  const contactCategoryData = Gstate.ContactDetailsEnumValues.ContactCategoryData || [];
  const filteredcompany = Gstate.Contacts.ContactData.filter(item => item.CrmType==="Company" && item.ContactTypeId===1);
  const companyListDataItems = filteredcompany || [];

  useEffect(() => {
    setLoading(false);
  }, [Gstate]);

   
  useEffect(()=>{
    dispatch(getContactsInfoAction(params.ContactId));
  },[])

  const ContactInfo = Gstate?.Contacts.ContactInfo || [];

  useEffect(() => {
    ContactInfo && setLoading(false);
    dispatch(getContactsDataAction(ContactInfo?.ContactInfo?.ContactTypeId));
  }, [ContactInfo]);

  const atributesData = ContactInfo?.ContactAttributes?.reduce((result, contact) => {
    const typeName = contact.ContactAttributeTypeName;
    if (!result[typeName]) {
      result[typeName] = [];
    }
    result[typeName].push(contact);
    return result;
  }, {});

  const defaultAttributeId = ContactGeneralAttributes.defaultAttributeId;
  const defaultEncrypted = ContactGeneralAttributes.isEncrypted;

  const businessEmail1 = atributesData?.["Business Email1"]?.[0];
  const businessEmail2 = atributesData?.["Business Email2"]?.[0];
  const businessEmail3 = atributesData?.["Business Email3"]?.[0];
  const businessPhone1 = atributesData?.["Business Phone1"]?.[0];
  const businessPhone2 = atributesData?.["Business Phone2"]?.[0];
  const businessPhone1Extension = atributesData?.["BusinessPhone1Extension"]?.[0];
  const businessPhone2Extension = atributesData?.["BusinessPhone2Extension"]?.[0];
  const department = atributesData?.["Department"]?.[0];
  const doNotEmail = atributesData?.["Do Not Email"]?.[0];
  const faxNumber = atributesData?.["Fax Number"]?.[0];
  const personalEmail1 = atributesData?.["Personal Email1"]?.[0];
  const personalEmail2 = atributesData?.["Personal Email2"]?.[0];
  const introductionDate = atributesData?.["Introduction Date"]?.[0];
  const mobilePhone = atributesData?.["Mobile Phone"]?.[0];
  const externalRepID = atributesData?.["Rep ID"]?.[0];
  const repTypeID = atributesData?.["Rep Type ID"]?.[0];
  const leadId = atributesData?.["Lead ID"]?.[0];
  const socialSecurity = atributesData?.["Social Security"]?.[0];
  const taxIDNumber = atributesData?.["Tax ID Number"]?.[0];
  const primaryContact = atributesData?.["Primary Contact ID"]?.[0];

  const contactId = params.ContactId;
  const contactTypeId = ContactInfo?.ContactInfo?.ContactTypeId;
  const contactSubTypeId = ContactInfo?.ContactInfo?.ContactSubTypeId;
  const companyName = ContactInfo?.ContactInfo?.CompanyName;
  const companyContactId = ContactInfo?.ContactInfo?.CompanyId;
  const contactCategoryId = ContactInfo?.ContactInfo?.ContactCategoryId;
  const contactCategoryName = ContactInfo?.ContactInfo?.ContactCategoryName;
  const dateOfBirth = ContactInfo?.ContactInfo?.DateOfBirth;
  const firstName = ContactInfo?.ContactInfo?.FirstName;
  const lastName = ContactInfo?.ContactInfo?.LastName;
  const middleName = ContactInfo?.ContactInfo?.MiddleName;
  const motherMaidenName = ContactInfo?.ContactInfo?.MotherMaidenName;
  const preferredName = ContactInfo?.ContactInfo?.PreferredName;
  const salutation = ContactInfo?.ContactInfo?.Salutation;
  const title = ContactInfo?.ContactInfo?.Title;
  const jobTitle = ContactInfo?.ContactInfo?.JobTitle;
  const jobRole = ContactInfo?.ContactInfo?.JobRole;
  const isMaster = ContactInfo?.ContactInfo?.IsMaster;
  const isParentCompany = ContactInfo?.ContactInfo?.IsParentCompany;
  const isActive = ContactInfo?.ContactInfo?.IsActive;
  const contactNotes = ContactInfo?.ContactInfo?.ContactNotes;
  const biographicalInfo = ContactInfo?.ContactInfo?.BiographicalInfo;
  const createdByUserName = ContactInfo?.ContactInfo?.CreatedByUserName;
  const createdDate = ContactInfo?.ContactInfo?.CreatedDate;

  const emptyContacts={
    contactTitle: null,
    middleName: null,
    socialSecurityValue: null,
    salutation: null,
    lastName: null,
    preferredName: null,
    taxIDValue: null,
    firstName: null,
    birthday: null,
    motherMaidenName: null,
    parentCompanyName: null,
    jobTitle: null,
    companyName: null,
    companyContactId: null,
    jobRole: null,
    departmentValue: null,
    businessPhone1Value: null,
    businessPhone1ExtensionValue: null,
    faxValue: null,
    personalEmail1Value: null,
    personalEmail2Value: null,
    businessPhone2Value: null,
    businessPhone2ExtensionValue: null,
    primaryContactValue: null,
    mobileValue: null,
    businessEmail1Value: null,
    contactCategoryId: null ,
    contactCategoryName: null,
    businessEmail2Value: null,
    externalRep: null,
    businessEmail3Value: null,
    repTypeValue: null,
    leadValue: null,
    introductionDate: null,
    createdDate: null,
    relatonshipMaster: null,
    doNotEmailValue: "",
    contactNotes:  null,
    biographicalInfo:  null,
    createdByUserName: "",
    createdDate: "",
  };

  const [generalState, setGeneralState] = useState(emptyContacts); 
  const [category, setCategory] = useState(null);
  const [repType, setRepType] = useState(null);
  const [company, setCompany] = useState(null);

  const getRepType = (repTypeValue) => {
 
    const selectedRepType = contactRepTypeData.find(
      (contactRepType) =>
        contactRepType && (contactRepType.EnumValue === parseInt(repTypeValue))
    );
  
    return selectedRepType ? selectedRepType : {};
  };
  

  useEffect(() => {
    if(params.ContactId !== "0"){
        setGeneralState({
          contactTitle: title,
          middleName: middleName,
          socialSecurityValue: socialSecurity?.ContactAttributeTypeValue,
          salutation: salutation,
          lastName: lastName,
          preferredName: preferredName,
          taxIDValue: taxIDNumber?.ContactAttributeTypeValue,
          firstName: firstName,
          birthday: dateOfBirth ? moment(dateOfBirth).format("MM/DD/yyyy") : null,
          motherMaidenName: motherMaidenName,
          parentCompanyName: isParentCompany?.ContactAttributeTypeValue,
          jobTitle: jobTitle,
          companyName: companyName,
          companyContactId: companyContactId,
          jobRole: jobRole,
          departmentValue: department?.ContactAttributeTypeValue,
          businessPhone1Value: businessPhone1?.ContactAttributeTypeValue,
          businessPhone1ExtensionValue: businessPhone1Extension?.ContactAttributeTypeValue,
          faxValue: faxNumber?.ContactAttributeTypeValue,
          personalEmail1Value: personalEmail1?.ContactAttributeTypeValue,
          personalEmail2Value: personalEmail2?.ContactAttributeTypeValue,
          businessPhone2Value: businessPhone2?.ContactAttributeTypeValue,
          businessPhone2ExtensionValue: businessPhone2Extension?.ContactAttributeTypeValue,
          primaryContactValue: primaryContact?.ContactAttributeTypeValue,
          mobileValue: mobilePhone?.ContactAttributeTypeValue,
          businessEmail1Value: businessEmail1?.ContactAttributeTypeValue,
          contactCategoryId: contactCategoryId ,
          contactCategoryName: contactCategoryName,
          businessEmail2Value: businessEmail2?.ContactAttributeTypeValue,
          externalRep: externalRepID?.contactAttributeId,
          businessEmail3Value: businessEmail3?.ContactAttributeTypeValue,
          repTypeValue: repTypeID?.ContactAttributeTypeValue,
          leadValue: leadId?.ContactAttributeTypeValue,
          introductionDate: introductionDate?.ContactAttributeTypeValue ? introductionDate?.ContactAttributeTypeValue : "",
          relatonshipMaster: isMaster,
          doNotEmailValue: doNotEmail?.ContactAttributeTypeValue || "",
          contactNotes: contactNotes,
          biographicalInfo:biographicalInfo,
          createdByUserName: createdByUserName,
          createdDate: createdDate,
        });

        const selectedRepType = getRepType(repTypeID?.ContactAttributeTypeValue);
        
        setCategory({EnumName: contactCategoryName, EnumValue: contactCategoryId});
        setRepType({EnumName: selectedRepType?.EnumName, EnumValue: selectedRepType?.EnumValue});
        setCompany({CompanyName: companyName, CompanyId: companyContactId});
      }      
  }, [ContactInfo]);

  const toggleSocialSecurityTextVisibility = () => {
    setSocialSecurityShowText(!showSocialSecurityText);
  };

  const toggleTaxTextVisibility = () => {
    setShowTaxText(!showTaxText);
  };

  const redirectLinkClick = () => {
    if(contactId !== "0"){
    history(`${UrlPath.InvestorDetails}${contactId}?ContactTypeId=${paramValue}`);
    }
    else{
      history(`${UrlPath.Investor}`);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setGeneralState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleDateChange = (date, fieldName) => {
      let formattedDate;
      if (true) {
          formattedDate = date!== null ? moment(date).format("MM/DD/yyyy") : null;
      }
      const updatedState = { ...generalState, [fieldName]: formattedDate };
      setGeneralState(updatedState);
  };

  const handleDropdown = (e, fieldName) => {
    const Value = e.value.EnumValue;
    const updatedState = { ...generalState, [fieldName]: Value };
    const newValue = {EnumName: e.value.EnumName ,EnumValue: e.value.EnumValue};
    if(fieldName === "contactCategoryId"){
      setGeneralState({ ...generalState, ["contactCategoryName"]: e.value.EnumName });
      setCategory(newValue);
    }
    if(fieldName === "repTypeValue"){
      setRepType(newValue);
    }
    setGeneralState(updatedState);
  };

  const handleCompanyDropdown = (e) => {
    const CompanyName = e?.value?.CompanyName || "";
    const CompanyContactId = e?.value?.CompanyId || 0;  
    const newValue = {CompanyName: CompanyName ,CompanyId: CompanyContactId};    
    setCompany(newValue);
    setGeneralState({...generalState, companyName: CompanyName, companyContactId: CompanyContactId});
  };

  const handleCheckbox = (e) => {
    const { name, checked } = e.target;
    let value;
    if(name === "relatonshipMaster"){
        value =  checked ? true : false;
    }
    if(name === "doNotEmailValue"){
      value =  !checked ? "0" : "1";
  }
    const updatedState = { ...generalState, [name]: value };
    setGeneralState(updatedState);
  };

  const contactAttributes = [];

  const fieldsToInclude = [
    "socialSecurityValue",
    "taxIDValue",
    "departmentValue",
    "businessPhone1Value",
    "businessPhone2Value",
    "businessPhone1ExtensionValue",
    "businessPhone2ExtensionValue",
    "mobileValue",  
    "faxValue",  
    "personalEmail1Value",
    "personalEmail2Value",
    "businessEmail1Value",
    "businessEmail2Value",
    "businessEmail3Value",
    "repTypeValue",
    "leadValue",
    "introductionDate",
    "doNotEmailValue",
    "primaryContactValue",
  ];
  
  for (const field of fieldsToInclude) {
    const value = generalState[field];
  
      let contactAttributeId;
      let contactAttributeTypeId;
      let contactAttributeTypeValue;
      let isEncrypted;
  
      switch (field) {
        case "socialSecurityValue":
          contactAttributeId = socialSecurity?.ContactAttributeId || defaultAttributeId;
          contactAttributeTypeId = ContactGeneralAttributes.SocialSecurity;
          contactAttributeTypeValue = generalState.socialSecurityValue;
          isEncrypted = true;
          break;
        case "taxIDValue":
          contactAttributeId = taxIDNumber?.ContactAttributeId || defaultAttributeId;
          contactAttributeTypeId = ContactGeneralAttributes.TaxIDNumber;
          contactAttributeTypeValue = generalState.taxIDValue;
          isEncrypted = true;
          break;
        case "departmentValue":
          contactAttributeId = department?.ContactAttributeId || defaultAttributeId;
          contactAttributeTypeId = ContactGeneralAttributes.Department;
          contactAttributeTypeValue = generalState.departmentValue;
          isEncrypted = department?.IsEncrypted || defaultEncrypted;
          break;
        case "businessPhone1Value":
          contactAttributeId = businessPhone1?.ContactAttributeId || defaultAttributeId;
          contactAttributeTypeId = ContactGeneralAttributes.BusinessPhone1;
          contactAttributeTypeValue = generalState.businessPhone1Value;
          isEncrypted = businessPhone1?.IsEncrypted || defaultEncrypted;
          break;
        case "businessPhone2Value":
          contactAttributeId = businessPhone2?.ContactAttributeId || defaultAttributeId;
          contactAttributeTypeId = ContactGeneralAttributes.BusinessPhone2;
          contactAttributeTypeValue = generalState.businessPhone2Value;
          isEncrypted = businessPhone2?.IsEncrypted || defaultEncrypted;
          break;
        case "businessPhone1ExtensionValue":
          contactAttributeId = businessPhone1Extension?.ContactAttributeId || defaultAttributeId;
          contactAttributeTypeId = ContactGeneralAttributes.BusinessPhone1Extension;
          contactAttributeTypeValue = generalState.businessPhone1ExtensionValue;
          isEncrypted = businessPhone1Extension?.IsEncrypted || defaultEncrypted;
          break;
        case "businessPhone2ExtensionValue":
          contactAttributeId = businessPhone2Extension?.ContactAttributeId || defaultAttributeId;
          contactAttributeTypeId = ContactGeneralAttributes.BusinessPhone2Extension;
          contactAttributeTypeValue = generalState.businessPhone2ExtensionValue;
          isEncrypted = businessPhone2Extension?.IsEncrypted || defaultEncrypted;
          break;
        case "mobileValue":
          contactAttributeId = mobilePhone?.ContactAttributeId || defaultAttributeId;
          contactAttributeTypeId = ContactGeneralAttributes.MobilePhone;
          contactAttributeTypeValue = generalState.mobileValue;
          isEncrypted = mobilePhone?.IsEncrypted || defaultEncrypted;
          break;
        case "faxValue":
          contactAttributeId = faxNumber?.ContactAttributeId || defaultAttributeId;
          contactAttributeTypeId = ContactGeneralAttributes.FaxNumber;
          contactAttributeTypeValue = generalState.faxValue;
          isEncrypted = faxNumber?.IsEncrypted || defaultEncrypted;
          break;
        case "personalEmail1Value":
          contactAttributeId = personalEmail1?.ContactAttributeId || defaultAttributeId;
          contactAttributeTypeId = ContactGeneralAttributes.PersonalEmail1;
          contactAttributeTypeValue = generalState.personalEmail1Value;
          isEncrypted = personalEmail1?.IsEncrypted || defaultEncrypted;
          break;
        case "personalEmail2Value":
          contactAttributeId = personalEmail2?.ContactAttributeId || defaultAttributeId;
          contactAttributeTypeId = ContactGeneralAttributes.PersonalEmail2;
          contactAttributeTypeValue = generalState.personalEmail2Value;
          isEncrypted = personalEmail2?.IsEncrypted || defaultEncrypted;
          break;
        case "businessEmail1Value":
          contactAttributeId = businessEmail1?.ContactAttributeId || defaultAttributeId;
          contactAttributeTypeId = ContactGeneralAttributes.BusinessEmail1;
          contactAttributeTypeValue = generalState.businessEmail1Value;
          isEncrypted = businessEmail1?.IsEncrypted || defaultEncrypted;
          break;
        case "businessEmail2Value":
          contactAttributeId = businessEmail2?.ContactAttributeId || defaultAttributeId;
          contactAttributeTypeId = ContactGeneralAttributes.BusinessEmail2;
          contactAttributeTypeValue = generalState.businessEmail2Value;
          isEncrypted = businessEmail2?.IsEncrypted || defaultEncrypted;
          break;
        case "businessEmail3Value":
          contactAttributeId = businessEmail3?.ContactAttributeId || defaultAttributeId;
          contactAttributeTypeId = ContactGeneralAttributes.BusinessEmail3;
          contactAttributeTypeValue = generalState.businessEmail3Value;
          isEncrypted = businessEmail3?.IsEncrypted || defaultEncrypted;
          break;
        case "repTypeValue":
          contactAttributeId = repTypeID?.ContactAttributeId || defaultAttributeId;
          contactAttributeTypeId = ContactGeneralAttributes.RepTypeID;
          contactAttributeTypeValue = generalState.repTypeValue;
          isEncrypted = repTypeID?.isEncrypted || defaultEncrypted;
          break;
        case "leadValue":
          contactAttributeId = leadId?.ContactAttributeId || defaultAttributeId;
          contactAttributeTypeId = ContactGeneralAttributes.LeadID;
          contactAttributeTypeValue = generalState.leadValue;
          isEncrypted = leadId?.IsEncrypted || defaultEncrypted;
          break;
        case "introductionDate":
          contactAttributeId = introductionDate?.ContactAttributeId || defaultAttributeId;
          contactAttributeTypeId = ContactGeneralAttributes.IntroductionDate;
          contactAttributeTypeValue = generalState.introductionDate;
          isEncrypted = introductionDate?.IsEncrypted || defaultEncrypted;
          break;
        case "doNotEmailValue":
          contactAttributeId = doNotEmail?.ContactAttributeId || defaultAttributeId;
          contactAttributeTypeId = ContactGeneralAttributes.DoNotEmail;
          contactAttributeTypeValue = generalState.doNotEmailValue;
          isEncrypted = doNotEmail?.IsEncrypted || defaultEncrypted;
          break;
        case "primaryContactValue":
          contactAttributeId = primaryContact?.ContactAttributeId || defaultAttributeId;
          contactAttributeTypeId = ContactGeneralAttributes.PrimaryContactID;
          contactAttributeTypeValue = generalState.primaryContactValue;
          isEncrypted = primaryContact?.IsEncrypted || defaultEncrypted;
          break;
      }
  
      const contactAttribute = {
        contactAttributeId: contactAttributeId,
        contactId: contactId,
        contactAttributeTypeId: contactAttributeTypeId,
        contactAttributeTypeValue: contactAttributeTypeValue === null ? "" : contactAttributeTypeValue,
        isEncrypted: isEncrypted === true ? 1 : 0,
        modifiedBy: 0,
      };
  
      contactAttributes.push(contactAttribute);
  }  

  const handleSave = async () => {

    let saveSuccess = true;

    const data = {
      contactInfo: {
        contactId: contactId,
        contactTypeId: contactTypeId || 1,
        title: generalState.contactTitle,
        salutation: generalState.salutation,
        firstName: generalState.firstName,
        middleName: generalState.middleName,
        lastName: generalState.lastName,
        preferredName: generalState.preferredName,
        motherMaidenName: generalState.motherMaidenName,
        dateOfBirth: generalState.birthday,
        companyId: generalState.companyContactId || 0,
        jobTitle: generalState.jobTitle,
        jobRole: generalState.jobRole,
        contactCategoryId: generalState.contactCategoryId || 0,
        contactInvestmentStatusId: 0,
        isMaster: generalState.relatonshipMaster === true ? 1 : 0,
        isActive: contactId !== "0" ? isActive === true ? 1 : 0 : 1,
        contactNotes: generalState.contactNotes,
        biographicalInfo:generalState?.biographicalInfo || "",
        modifiedBy: 0,
      },
      contactAttributes: contactAttributes,
    };
    
    const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
    const phoneno =
      /^(([+]?([0-9]{1,3}))?[-. ])?(\([0-9]{3}\)|[0-9]{3})[-. ]?(\([0-9]{3}\)|[0-9]{3})[-. ]?(\([0-9]{4}\)|[0-9]{4})$/;
    const ssRegex =
      /^(?!000|666)[0-8][0-9]{2}-(?!00)[0-9]{2}-(?!0000)[0-9]{4}$/;
    const r = /^[0-9]{3}-[0-9]{2}-[0-9]{4}$/;
    const s = /^[0-9]{2}-[0-9]{7}$/;
    const dateregexp =
      /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;

      if (!generalState.salutation || generalState.salutation.trim() === "") {
        SBNotify({ type: "error", Msg: "Please Enter Salutation" });
        saveSuccess = false;
      } else if (!generalState.firstName || generalState.firstName.trim() === "") {
        SBNotify({ type: "error", Msg: "Please Enter First Name" });
        saveSuccess = false;
      } else if (!generalState.lastName || generalState.lastName.trim() === "") {
        SBNotify({ type: "error", Msg: "Please Enter Last Name" });
        saveSuccess = false;
      } else if (generalState.birthday !== null)
      if
        ( generalState.birthday !== "" && !dateregexp.test(generalState.birthday))
       {
        SBNotify({ type: "error", Msg: "Invalid Date of Birth" });
        saveSuccess = false;
      }

    const validateEmail = (attributeValue, regex, errorMsg) => {
      if (attributeValue !== "" && !regex.test(attributeValue)) {
        SBNotify({ type: "error", Msg: errorMsg });
        saveSuccess = false;
      }
    };
    const validatePhone = (attributeValue, regex, errorMsg) => {
      if (attributeValue !== "" && !regex.test(attributeValue)) {
        SBNotify({ type: "error", Msg: errorMsg });
        saveSuccess = false;
      }
    };
    const validateSocialSecurity = (attributeValue, regex, errorMsg) => {
      if (attributeValue !== "" && !regex.test(attributeValue)) {
        SBNotify({ type: "error", Msg: errorMsg });
        saveSuccess = false;
      }
    };
    const validateTaxIDNumber = (attributeValue) => {
      const resultTinSocial = r.test(attributeValue);
      const resultTin = s.test(attributeValue);

      return !(resultTinSocial || resultTin);
    };
    const validateIntroductionDate = (attributeValue, regex, errorMsg) => {
      const currentDate = new Date();
      const newDate = new Date(attributeValue);

      if (attributeValue !== "" && newDate > currentDate) {
        SBNotify({ type: "error", Msg: errorMsg });
        saveSuccess = false;
      }
    
      if (attributeValue !== "" && !regex.test(attributeValue)) {
        SBNotify({ type: "error", Msg: errorMsg });
        saveSuccess = false;
      }
    };

    contactAttributes.forEach((attribute) => {
      const { contactAttributeTypeId, contactAttributeTypeValue } = attribute;

      switch (contactAttributeTypeId) {
        case ContactGeneralAttributes.BusinessEmail1:
          validateEmail(
            contactAttributeTypeValue,
            emailRegex,
            "invalid Business Email"
          );
          break;
        case ContactGeneralAttributes.BusinessEmail2:
          validateEmail(
            contactAttributeTypeValue,
            emailRegex,
            "invalid Business Email 2"
          );
          break;
        case ContactGeneralAttributes.BusinessEmail3:
          validateEmail(
            contactAttributeTypeValue,
            emailRegex,
            "invalid Business Email 3"
          );
          break;
        case ContactGeneralAttributes.PersonalEmail1:
          validateEmail(
            contactAttributeTypeValue,
            emailRegex,
            "invalid Personal Email 1"
          );
          break;
        case ContactGeneralAttributes.PersonalEmail2:
          validateEmail(
            contactAttributeTypeValue,
            emailRegex,
            "invalid Personal Email 2"
          );
          break;
        case ContactGeneralAttributes.BusinessPhone1:
          validatePhone(
            contactAttributeTypeValue,
            phoneno,
            "invalid Business Phone 1"
          );
          break;
        case ContactGeneralAttributes.BusinessPhone2:
          validatePhone(
            contactAttributeTypeValue,
            phoneno,
            "invalid Business Phone 2"
          );
          break;
        case ContactGeneralAttributes.MobilePhone:
          validatePhone(
            contactAttributeTypeValue,
            phoneno,
            "invalid MobilePhone"
          );
          break;
        case ContactGeneralAttributes.SocialSecurity:
          validateSocialSecurity(
            contactAttributeTypeValue,
            ssRegex,
            "invalid Social Security"
          );
          break;
        case ContactGeneralAttributes.TaxIDNumber:
          if (
            contactAttributeTypeValue !== "" &&
            validateTaxIDNumber(contactAttributeTypeValue)
          ) {
            SBNotify({ type: "error", Msg: "Invalid TaxID Number" });
            saveSuccess = false;
          }
          break;
        case ContactGeneralAttributes.IntroductionDate:
          validateIntroductionDate(
            contactAttributeTypeValue,
            dateregexp,
            "Please select valid Intro Date"
          );
          break;

        default:
          break;
      }
    });
  

  if (saveSuccess) {
    const response = await sbaAxios({
      url: `${insertOrUpdateContactGeneral}`,
      method: "post",
      data: data,
    });
    if (response > 0) {
      SBNotify({ type: "success", Msg: "Updated Successfully" });
      redirectLinkClick();
    }
      else {
        SBNotify({ type: "warning", Msg: "Failed" }); 
      }
    }  

  };

  return (
    <>
      {loading ? (
        <>
          <LoadingScreen />
        </>
      ) : (
        <>
          <div id="contacts" className="mainContentData">
            <div className="bg-white m-3 p-border rounded">
              <div className="bg-white p-4">
                <div className="content-container">
                  <div className="col-lg-12 px-0">
                    <div className="row m-0">
                      <div className="col-md-4">
                        <div className="mb-4">
                          <span className="fw-medium">Title</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="contactTitle"
                            Value={generalState.contactTitle}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="mb-4">
                          <span className="fw-medium">Middle Name</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="middleName"
                            Value={generalState.middleName}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="mb-4" style={{ alignItems: "center" }}>
                          <span className="d-flex">
                            <span className="fw-medium">Social Security</span>
                            <span
                              className="ms-2 roundedIcon"
                              title={`Supported Formats:                          
                          000-00-0000
                         `}
                            >
                              ?
                            </span>
                          </span>
                          <div style={{ flex: 1, position: "relative" }}>
                            <input
                              className="form-control w-75"
                              type={
                                showSocialSecurityText ? "text" : "password"
                              }
                              name="socialSecurityValue"
                              value={generalState.socialSecurityValue}
                              onChange={handleChange}
                            />
                            <span
                              className="contact-edit-eye"
                              onClick={toggleSocialSecurityTextVisibility}
                            >
                              {showSocialSecurityText ? (
                                <i className="fa-solid fa-eye"></i>
                              ) : (
                                <i className="fa-regular fa-eye-slash"></i>
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-4">
                          <span className="fw-medium">Salutation</span>
                          <span class="mandatory">*</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="salutation"
                            Value={generalState.salutation}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="mb-4">
                          <span className="fw-medium">Last Name</span>
                          <span class="mandatory">*</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="lastName"
                            Value={generalState.lastName}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="mb-4" style={{ alignItems: "center" }}>
                        <span className="d-flex">
                          <span className="fw-medium">Tax ID Number</span>
                          <span
                              className="ms-2 roundedIcon"
                              title={`Supported Formats:                          
                          000-00-0000
                          00-0000000
                         `}
                            >
                              ?
                            </span>
                            </span>
                          <div style={{ flex: 1, position: "relative" }}>
                            <input
                              className="form-control w-75"
                              type={showTaxText ? "text" : "password"}
                              name="taxIDValue"
                              value={generalState.taxIDValue}
                              onChange={handleChange}
                            />
                            <span
                              className="contact-edit-eye"
                              onClick={toggleTaxTextVisibility}
                            >
                              {showTaxText ? (
                                <i className="fa-solid fa-eye"></i>
                              ) : (
                                <i className="fa-regular fa-eye-slash"></i>
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-4">
                          <span className="fw-medium">First Name</span>
                          <span class="mandatory">*</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="firstName"
                            Value={generalState.firstName}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="my-4">
                          <span className="fw-medium">D.O.B</span>
                          <div className="w-75Test">
                            <SBDatePicker
                              className="form-control w-75"
                              value={generalState.birthday ? moment(generalState.birthday) : null}
                              style={{ height: "33px" }}
                              name="birthday"
                              onChange={(date) =>
                                handleDateChange(date, "birthday")
                              }
                            ></SBDatePicker>
                          </div>
                        </div>
                        <div className="mb-4">
                          <span className="fw-medium">
                            Mother's Maiden Name
                          </span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="motherMaidenName"
                            Value={generalState.motherMaidenName}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr />

                  <div className="col-lg-12 px-0">
                    <div className="row m-0">
                      <div className="col-md-4">
                        <div className="mb-4">
                          <span className="fw-medium">Company</span>
                          <div>
                            <SBAComboBox
                              className="w-75"
                              data={companyListDataItems}
                              textField={"CompanyName"}
                              valueField={"CompanyId"}
                              name="companyName"
                              value={company}
                              onChange={(e) => handleCompanyDropdown(e)}
                            />
                          </div>
                        </div>
                    
                        <div className="mb-4">
                          <span className="fw-medium">Job Title</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="jobTitle"
                            Value={generalState.jobTitle}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                      <div className="mb-4">
                          <span className="fw-medium">Department</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="departmentValue"
                            Value={generalState.departmentValue}
                            onChange={handleChange}
                          />
                        </div>
                     
                      </div>
                      <div className="col-md-4">
                      <div className="mb-4">
                          <span className="fw-medium">Job Role</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="jobRole"
                            Value={generalState.jobRole}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr />

                  <div className="col-lg-12 px-0">
                    <div className="row m-0">
                      <div className="col-md-4">
                        <div className="mb-4">
                          <span className="d-flex">
                            <span className="fw-medium">Business Phone 1</span>
                            <span
                              className="ms-2 roundedIcon"
                              title={`Supported Formats: 
                          +00 000 000 0000
                          +0 0000000000
                          000-000-0000
                          000 000 0000
                          (000) 000 0000
                          (000) (000) (0000)`}
                            >
                              ?
                            </span>
                          </span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="businessPhone1Value"
                            Value={generalState.businessPhone1Value}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="mb-4">
                          <span className="fw-medium">
                            Business Phone 1 Extn
                          </span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="businessPhone1ExtensionValue"
                            Value={
                              generalState.businessPhone1ExtensionValue
                            }
                            onChange={handleChange}
                          />
                        </div>
                        <div className="mb-4">
                          <span className="fw-medium">Fax Number</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="faxValue"
                            Value={generalState.faxValue}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-4">
                          <span className="d-flex">
                            <span className="fw-medium">Business Phone 2</span>
                            <span
                              className="ms-2 roundedIcon"
                              title={`Supported Formats: 
                          +00 000 000 0000
                          +0 0000000000
                          000-000-0000
                          000 000 0000
                          (000) 000 0000
                          (000) (000) (0000)`}
                            >
                              ?
                            </span>
                          </span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="businessPhone2Value"
                            Value={generalState.businessPhone2Value}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="mb-4">
                          <span className="fw-medium">
                            Business Phone 2 Extn
                          </span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="businessPhone2ExtensionValue"
                            Value={
                              generalState.businessPhone2ExtensionValue
                            }
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-4">
                          <span className="fw-medium">Primary Contact</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="primaryContactValue"
                            Value={generalState.primaryContactValue}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="mb-4">
                          <span className="d-flex">
                            <span className="fw-medium">Mobile Phone</span>
                            <span
                              className="ms-2 roundedIcon"
                              title={`Supported Formats: 
                          +00 000 000 0000
                          +0 0000000000
                          000-000-0000
                          000 000 0000
                          (000) 000 0000
                          (000) (000) (0000)`}
                            >
                              ?
                            </span>
                          </span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="mobileValue"
                            Value={generalState.mobileValue}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr />

                  <div className="col-lg-12 px-0">
                    <div className="row m-0">
                      <div className="col-md-4">
                        <div className="mb-4">
                          <span className="fw-medium">Business Email</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="businessEmail1Value"
                            Value={generalState.businessEmail1Value}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="mb-4">
                          <span className="fw-medium">Personal Email 1</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="personalEmail1Value"
                            Value={generalState.personalEmail1Value}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-4">
                          <span className="fw-medium">Business Email 2</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="businessEmail2Value"
                            Value={generalState.businessEmail2Value}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="mb-4">
                          <span className="fw-medium">Personal Email 2</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="personalEmail2Value"
                            Value={generalState.personalEmail2Value}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-4">
                          <span className="fw-medium">Business Email 3</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="businessEmail3Value"
                            Value={generalState.businessEmail3Value}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr />

                  <div className="col-lg-12 px-0">
                    <div className="row m-0">
                      <div className="col-md-4">
                        <div className="mb-4">
                          <span className="fw-medium">Investor Category</span>
                          <div>
                            <SBADropDown
                              className="w-75"
                              data={contactCategoryData}
                              textField={"EnumName"}
                              valueField={"EnumValue"}
                              name="category"
                              value={category}
                              onChange={(e) =>
                                handleDropdown(e, "contactCategoryId")
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-4">
                          <span className="fw-medium">Rep Type</span>
                          <div>
                            <SBADropDown
                              className="w-75"
                              data={contactRepTypeData}
                              textField={"EnumName"}
                              valueField={"EnumValue"}
                              name="repTypeValue"
                              value={repType}
                              onChange={(e) =>
                                handleDropdown(e, "repTypeValue")
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-4">
                          <span className="fw-medium">Introduction Date</span>
                          <div className="W-75">
                            <SBDatePicker
                              className="form-control w-75"
                              value={generalState.introductionDate ? moment(generalState.introductionDate) : null}
                              style={{ height: "33px" }}
                              onChange={(date) =>
                                handleDateChange(date, "introductionDate")
                              }
                            ></SBDatePicker>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 px-0">
                    <div className="row m-0">
                      <div className="col-md-4">
                        <div className="mb-4">
                          <span className="fw-medium">Created by</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="createdBy"
                            Value={generalState.createdByUserName}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-4">
                          <span className="fw-medium">Created Date</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            Value={
                              generalState.createdDate
                                ? moment(generalState.createdDate).format(
                                    "MM/DD/YYYY"
                                  )
                                : "-"
                            }
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr />

                    <div className="col-lg-12 px-0">
                      <div className="row m-0">
                        <div className="col-md-2">
                          <div className="">
                            <label className="d-flex align-items-center gap-3">
                              <input
                                type="checkbox"
                                className="m-0"
                                name="relatonshipMaster"
                                checked={generalState.relatonshipMaster === true}
                                onChange={handleCheckbox}
                              />
                              <span className="fw-medium">
                                Relationship Master
                              </span>
                            </label>
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="">
                            <label className="d-flex align-items-center gap-3">
                              <input
                                type="checkbox"
                                name="doNotEmailValue"
                                checked={generalState.doNotEmailValue === "1"}
                                onChange={handleCheckbox}
                              />
                              <span className="fw-medium">Do not Email</span>
                            </label>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="">
                            <label>
                              <span className="fw-medium">Biographical Info</span>

                            </label>
                            <textarea
                              className="form-control"
                              style={{ height: "200px", width: "100%" }}
                              name="biographicalInfo"
                              value={generalState.biographicalInfo}
                              onChange={handleChange}
                            ></textarea>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="col-lg-12">
                            <div className="">
                              <label>
                                <span className="fw-medium">Notes</span>
                                </label>
                                <textarea
                                  className="form-control"
                                  style={{ height: "200px", width: "100%" }}
                                  name="contactNotes"
                                  value={generalState.contactNotes}
                                  onChange={handleChange}
                                ></textarea>
                           
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            <div className="col-lg-12 px-0">
              <UpdateorCancelButtons
                onSave={handleSave}
                onCancel={redirectLinkClick}
              />
            </div>
          </div>
        </>
      )}
      <ToastContainer />
    </>
  );
};
